import { Link } from "react-router-dom";
import { articles, categories } from "@/mocks/content";
import ArticleCard from "@/components/feature/ArticleCard";

const latestIds = ["a3", "a5", "a6", "a7", "a8", "a9"];

function SectionHead({
  eyebrow,
  title,
  moreTo,
  moreLabel,
}: {
  eyebrow: string;
  title: string;
  moreTo: string;
  moreLabel: string;
}) {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <p className="text-xs font-bold tracking-[0.25em] text-primary-600">{eyebrow}</p>
        <h2 className="mt-1 font-display text-2xl font-black text-foreground-950 md:text-3xl">
          {title}
        </h2>
      </div>
      <Link
        to={moreTo}
        className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-600 transition-colors hover:text-primary-600"
      >
        {moreLabel} <i className="ri-arrow-right-line" aria-hidden="true" />
      </Link>
    </div>
  );
}

export default function LatestFeed() {
  const latest = latestIds.map((id) => articles.find((a) => a.id === id)!).filter(Boolean);

  return (
    <>
      {/* category showcase */}
      <section className="border-b border-background-300/60 bg-background-100/70">
        <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
          <SectionHead
            eyebrow="按栏目逛瓜田"
            title="四个角度，把瓜吃得明明白白"
            moreTo="/news"
            moreLabel="浏览全部"
          />
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {categories.map((c) => (
              <Link
                key={c.id}
                to={`/news?c=${c.id}`}
                className="group flex flex-col rounded-2xl bg-background-50 p-6 ring-1 ring-background-200/70 transition-all hover:-translate-y-1 hover:ring-primary-300"
              >
                <span className={`flex h-12 w-12 items-center justify-center rounded-xl text-background-50 ${c.dot}`}>
                  <i
                    className={
                      "text-xl " +
                      (c.id === "timeline"
                        ? "ri-node-tree"
                        : c.id === "clue"
                          ? "ri-focus-3-line"
                          : c.id === "mystery"
                            ? "ri-questionnaire-line"
                            : "ri-group-line")
                    }
                    aria-hidden="true"
                  />
                </span>
                <h3 className="mt-4 font-display text-xl font-bold text-foreground-950">
                  {c.name}
                </h3>
                <p className="mt-1 text-xs font-medium tracking-widest text-primary-500">{c.en}</p>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                  去看看 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* latest grid */}
      <section className="bg-background-50">
        <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
          <SectionHead
            eyebrow="今日上架"
            title="最新瓜报 · 细节与节奏"
            moreTo="/news"
            moreLabel="进入速递"
          />
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {latest.map((a) => (
              <ArticleCard key={a!.id} article={a!} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}